import { create } from 'zustand'
import {getSlurryEmissions} from '../API/apis'


export const useInputStore = create((set) => ({
  postcode: "EH9 3GT",
  n_cows: 100,
  // TODO: remove hardcoded dates
  date_in: "2025-10-01",
  date_out: "2026-04-01",
  digest_energy: 0.7,
  milk_yield: 9000,
  sim_start_date: "2025-01-01",
  sim_end_date: "2025-12-31",
  date_empty: "2025-06-01",
  email: "",
  who_are_you: "",

  set_value: 
    async (updates) => {
        set(
            (state) => (
                {...state, ...updates }
            )
        )}
    , 
}))

export const useFetchingStore = create((set) => ({
    fetching: false,
    resp: [{'data':[],'units':{},'human_readable':{}}],
    fetch: async (request) => {
        set({ fetching: true })
    
        try {
            const response = await getSlurryEmissions(request)
    
            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`)
            }
    
            const data = await response.json()
            data.date_empty = request.date_empty || '';
    
            set((state) => ({
                resp: [...state.resp, data],
                fetching: false
            }))
    
        } catch (error) {
            // TODO: do we want the error visible in the console?
            console.error('Error in fetch:', error)
            throw error
        } finally {
            set({ fetching: false })
        }
    }
}))
